import { render, staticRenderFns } from "./ClientExtraCostForm.vue?vue&type=template&id=4a2c1228"
import script from "./ClientExtraCostForm.vue?vue&type=script&lang=js"
export * from "./ClientExtraCostForm.vue?vue&type=script&lang=js"
import style0 from "./ClientExtraCostForm.vue?vue&type=style&index=0&id=4a2c1228&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports